export default __webpack_public_path__ + "static/media/merry-christmas.28140f87.webp";